export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-31',
  growthbookFeatures: ['supp', 'thankyou_tips'],
  sexologyUpsellEnabled: false,
};
